import script from "./Warehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./Warehouse.vue?vue&type=script&setup=true&lang=js"

import "./Warehouse.vue?vue&type=style&index=0&id=c68c1dee&lang=css"

const __exports__ = script;

export default __exports__